var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bill-form-container"
  }, [_c('div', {
    staticClass: "section-container"
  }, [_c('substrate-mount', [_c('div', {
    staticClass: "composite-textarea"
  }, [_c('input-textarea', {
    ref: "billDescription",
    attrs: {
      "input-id": "bill-description",
      "input-name": _vm.$t('common.description'),
      "input-title": _vm.$t('enter.description'),
      "input-placeholder": _vm.$t('what.paid'),
      "max-length": 510,
      "required": false,
      "rows": 1,
      "composite": ""
    },
    model: {
      value: _vm.bill.description,
      callback: function callback($$v) {
        _vm.$set(_vm.bill, "description", $$v);
      },
      expression: "bill.description"
    }
  }), _c('attachment-image', {
    attrs: {
      "link": _vm.bill.attachment.link,
      "input-id": "bill.attachment",
      "type": "secondary",
      "composite": "",
      "composite-textarea": ""
    },
    on: {
      "loading": _vm.onImageLoading,
      "uploaded": function uploaded(data) {
        return _vm.bill.attachment.setData(data);
      },
      "reset": function reset($event) {
        return _vm.bill.attachment.reset();
      }
    }
  })], 1), _c('labeled-input', {
    attrs: {
      "label": _vm.$t('amount.for.pay', {
        getCurrencySign: _vm.currency.sign
      }),
      "placeholder": "0 ".concat(_vm.currency.sign),
      "error": _vm.$v.bill.amount.$error,
      "force-replace": [[/[^0-9\.\,]+/g, ''], [/^\./g, ''], [/\,/, '\.']],
      "force-format": [_vm.$formatInputAmount({
        significantZeros: _vm.currency.significant_zeros,
        decimalsSeparator: '.',
        thousandSeparator: ' '
      })]
    },
    on: {
      "focus": _vm.$v.bill.amount.$reset,
      "blur": _vm.$v.bill.amount.$touch
    },
    model: {
      value: _vm.bill.amount,
      callback: function callback($$v) {
        _vm.$set(_vm.bill, "amount", $$v);
      },
      expression: "bill.amount"
    }
  }), _c('div', {
    staticClass: "switcher-container"
  }, [_c('cs-switcher', {
    attrs: {
      "label": _vm.$t('allow.multiple.bill.payments')
    },
    model: {
      value: _vm.bill.isMulti,
      callback: function callback($$v) {
        _vm.$set(_vm.bill, "isMulti", $$v);
      },
      expression: "bill.isMulti"
    }
  })], 1), _c('div', {
    staticClass: "switcher-container"
  }, [_c('cs-switcher', {
    attrs: {
      "label": _vm.$t('organize.content.delivery')
    },
    on: {
      "input": function input($event) {
        _vm.bill.contentUrl = '';
      }
    },
    model: {
      value: _vm.bill.isContentUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.bill, "isContentUrl", $$v);
      },
      expression: "bill.isContentUrl"
    }
  })], 1), _vm.bill.isContentUrl ? _c('div', {
    staticClass: "input-container"
  }, [_c('input-link-or-iframe', {
    ref: "billContentUrl",
    attrs: {
      "input-id": "bill-content-url",
      "input-name": _vm.$t('link.to.content.or.code.for.embedding'),
      "input-placeholder": "https://mysite.ru/myfile.pdf",
      "capusta-info": "billIframe"
    },
    on: {
      "showInfo": function showInfo($event) {
        return _vm.$emit('showInfo');
      }
    },
    model: {
      value: _vm.bill.contentUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.bill, "contentUrl", $$v);
      },
      expression: "bill.contentUrl"
    }
  })], 1) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "button-primary-container"
  }, [_c('cs-button', {
    attrs: {
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('get.link')) + " ")])], 1), _c('div', {
    staticClass: "button-secondary-container"
  }, [_c('cs-button', {
    attrs: {
      "type": "secondary",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.onSubmitWithQrCode
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('cs-icon', {
    attrs: {
      "name": "qr-code",
      "size": "extra-medium"
    }
  })], 1), _vm._v(" " + _vm._s(_vm.$t('get.qr')) + " ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }